export default __webpack_public_path__ + "static/media/facebook.acf10106.svg";